export const cpfValido = ( cpf ) => {
    let cpfOK = true

    if (cpf.length > 0) {

        cpfOK = false

        if (cpf.length === 11) {

            const digitoDigitado = Number(cpf.substr(9, 1) + cpf.substr(10, 1))

            let soma1 = 0
            let soma2 = 0

            let valor = 10

            for(let i = 0; i < 9; i++) {
                soma1 += Number(cpf.substr(i, 1)) * valor
                soma2 += Number(cpf.substr(i, 1))
                valor--
            }

            let digito1 = (11 * (1 + Math.floor(soma1 / 11))) - soma1

            if (digito1 > 9) {
                digito1 = 0
            }

            soma1 = soma1 + soma2 + digito1 + digito1

            let digito2 = (11 * (1 + Math.floor(soma1 / 11))) - soma1

            if (digito2 > 9) {
                digito2 = 0
            }

            const digitoGerado = (digito1 * 10) + digito2

            if (digitoGerado === digitoDigitado) {
                cpfOK = true
            }      
        }
    }

    return cpfOK
}